import { z } from 'zod'

export const StringDtoSchema = z.string()

export type StringDto = z.infer<typeof StringDtoSchema>
